exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.big-menu[data-v-4ae9db1a] {\n\tpadding: 0 16px 0 0;\n}\n.small-menu[data-v-4ae9db1a] {\n\tpadding: 0 5px 0 0;\n}\n.label-checkbox[data-v-4ae9db1a] {\n\tpadding: 2px 0 0 0;\n}\n.a-border-bottom[data-v-4ae9db1a] {\n\tborder-bottom: 1px solid rgba(0, 0, 0, 0.1);\n}\n", ""]);

// exports
